import React, { memo } from 'react'
import { useLocation } from 'react-router-dom'

import { routingConstants } from 'constants/routingConstants'
import Link from 'components/CommonUI/Link/Link'
import { getIsSuperUserSelector } from 'redux/reducers/profile'
import { useShallowEqualSelector } from 'custom-hooks'
import FacilityMenu from './FacilityMenu'
import AdminToolMenu from './AdminToolMenu'
import OverviewMenu from './OverviewMenu'

function HeaderNav() {
  const { pathname } = useLocation()
  const isSuperUser = useShallowEqualSelector(getIsSuperUserSelector)

  return (
    <div className="header_item header_nav_container">
      <OverviewMenu />
      <FacilityMenu />
      {isSuperUser && <AdminToolMenu pathname={pathname} />}
      <Link
        to={routingConstants.helpSupport}
        className={`nav_item ${
          pathname.includes(routingConstants.helpSupport) ? 'active' : ''
        }`}
      >
        {'Help & Support'}
      </Link>
    </div>
  )
}

export default memo(HeaderNav)
